import axios from "axios";

// El backend siempre está en el MISMO origen que el frontend en Emergent (ingress hace
// path routing por `/api`). Usar window.location.origin evita que un REACT_APP_BACKEND_URL
// cacheado en un bundle viejo apunte a una URL de preview rotada (→ 404 del ingress).
// Cuando el preview se duerme, la plataforma sirve una copia estática en
// `*.preview.static.emergentagent.com` que solo acepta GET (POST → 403).
// Normalizamos al host vivo para que la API y el callback OAuth funcionen.
const STATIC_MARKER = ".preview.static.";
export const isStaticSnapshotHost = () =>
  typeof window !== "undefined" && window.location.hostname.includes(STATIC_MARKER);

export const toLiveOrigin = (origin) => origin.replace(STATIC_MARKER, ".preview.");

const runtimeOrigin =
  typeof window !== "undefined" && window.location?.origin
    ? toLiveOrigin(window.location.origin)
    : process.env.REACT_APP_BACKEND_URL;

export const APP_ORIGIN = runtimeOrigin;
export const API = `${runtimeOrigin}/api`;

const TOKEN_KEY = "relevo_session_token";

export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  // Cookies no viajan cross-origin cuando el ingress fuerza
  // `access-control-allow-origin: *`. Usamos Bearer token en su lugar.
});

// Adjunta Bearer en cada request si hay token guardado.
api.interceptors.request.use((config) => {
  const t = getAuthToken();
  config.headers = config.headers || {};
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  config.headers["X-Lang"] = localStorage.getItem("relevo_lang") || ((navigator.language || "es").toLowerCase().startsWith("en") ? "en" : "es");
  return config;
});

// Purga el token si el servidor invalida la sesión.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      if (!url.includes("/auth/session") && !url.includes("/auth/login") && !url.includes("/auth/register")) {
        if (getAuthToken()) setAuthToken(null);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
